'use client';

import React from 'react';
import { motion } from 'framer-motion';
import InfoBlock from './InfoBlock';
import RandomText from './RandomText';
import { AboutPage } from '@/lib/strapi';

interface Props {
  data: AboutPage | null;
  lang: string;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

export default function AboutTilesSection({ data, lang }: Props) {
  const pillars = data?.ValuePillar?.slice(0, 3) || [];
  
  if (pillars.length === 0) return null;

  return (
    <section className="py-24 bg-slate-50 px-6 overflow-hidden min-h-[600px] border-y border-slate-100">
      <div className="max-w-7xl mx-auto">
        {/* Заголовок секции (как в ServicesGrid) */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 text-center"
        >
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-6 tracking-tighter">
            <RandomText text={data?.HomeBlockTtitle || data?.maintitle || (lang === 'ru' ? 'О нас' : 'About Us')} />
          </h2>
          <div className="w-24 h-1.5 bg-blue-600 mx-auto rounded-full mb-8" />
          {data?.Slogan && (
            <p className="text-xl text-slate-500 max-w-2xl mx-auto font-light">
              <RandomText text={data.Slogan} delay={0.2} />
            </p>
          )}
        </motion.div>
        
        {/* Сетка (как в ServicesGrid) */}
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10"
        >
          {pillars.map((pillar, idx) => (
            <InfoBlock 
              key={pillar.id} 
              data={pillar} 
              mode="summary" 
              index={idx} 
              lang={lang}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
